export enum DocOperation{
	EDIT_CHAPTER_CUSTOM = 'EDIT_CHAPTER_CUSTOM',
	TREAT_EDIT_CHAPTER_TREAT = 'TREAT_EDIT_CHAPTER_TREAT',
	TREAT_EDIT_CHAPTER_CHECK_RA_DPIA = 'TREAT_EDIT_CHAPTER_CHECK_RA_DPIA',
	TREAT_EDIT_CHAPTER_LIA = 'TREAT_EDIT_CHAPTER_LIA',
	VALIDATE = 'VALIDATE',
	PUBLISH = 'PUBLISH',
	REOPEN = 'REOPEN',
	DPIA_COMMENT = 'DPIA_COMMENT',
	DTB_OPEN = 'DTB_OPEN',
	DTB_CLOSE = 'DTB_CLOSE',
	DTB_DELETE = 'DTB_DELETE',
	DTB_CANCEL_DELETE = 'DTB_CANCEL_DELETE',
	SNAPSHOT = 'SNAPSHOT',
	DELETE = 'DELETE',
	OBSOLETE = 'OBSOLETE',
}
